import { createContext, useContext } from "react";

import { useProducePollingCtxProvider } from "./hooks-context-providers";

export type IUseProducePolling = ReturnType<
  typeof useProducePollingCtxProvider
>;

const ProducePollingContext = createContext<IUseProducePolling>(
  {} as IUseProducePolling,
);

ProducePollingContext.displayName = "ProducePollingContext";

export const useProducePollingContext = (): IUseProducePolling =>
  useContext(ProducePollingContext);

export { ProducePollingContext };
